import { Injectable } from '@angular/core';
import { HttpService } from '../../shared/services/http/http.service';
import { RestService } from '../../shared/services/http/rest.service';
import {environment} from '../../environments/environment';

@Injectable()
export class HeaderService extends RestService{

  queryName = 'CHANGEOPP';
  ajaxLoaderEnabled = true;
  url = environment.http.baseUrl;

  constructor(httpService: HttpService) {
    super(httpService);
  }

  asignOpportunity(payload) {
    this.baseUrl =  '/assignuser/';
    return this.update('', '', payload);
  }

  transferOpportunity(payload){
    this.baseUrl =  '/transferopportunity/';
    return this.save('', '', payload);
  }

  nodeInfo() {
    this.baseUrl =  '/nodeinfo/';
    return this.query();
  }

  viewAs(payload) {
    this.baseUrl =  '/viewasuser/';
    return this.update('', '', payload);
  }

  getAllEmailIds() {
    this.baseUrl = '/viewasuser/';
    return this.query();
  }
}
